import i18n from "i18next";
import * as Yup from "yup";

import type { CountryCode } from "@krea/shared/types/common";
import { orgNumValidator } from "@krea/shared/utils/orgNumValidator";

export const OrganisationValidation = (countryCode: CountryCode) => {
  return Yup.object().shape({
    organisationNumber: Yup.string()
      .required(
        i18n.t("formFields.companyErrors.orgNumberRequired", {
          ns: "formFields",
        }),
      )
      .test("organisationNumber", function (value) {
        const { path, createError } = this;
        const isValid = orgNumValidator(value ?? "", countryCode).isValid;

        return (
          isValid ||
          createError({
            path,
            message: i18n.t("formFields.companyErrors.orgNumberInvalid", {
              ns: "formFields",
            }),
          })
        );
      }),
    name: Yup.string().required(
      i18n.t("formFields.companyErrors.orgNameRequired", { ns: "formFields" }),
    ),
  });
};
